module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio71-ccd75e0a6ed3c9da0d3f3edd132b1e8d.m4a";